import { serviceEndpoints } from '../constants';
import { AxiosMethod, defaultAxiosOptions } from '../constants/axios.constants';
import { AxiosPromise, AxiosRequestConfig } from 'axios';
import useAxios from 'axios-hooks';
import { ResponseValuesOverride } from '../models/response-values-override';

export function useCheckAuthenticationRequest<T>(): [
  ResponseValuesOverride<T>,
  () => AxiosPromise<T>,
] {
  const config: AxiosRequestConfig = {
    method: AxiosMethod.Get,
    url: serviceEndpoints.authenticationApi(),
  };

  const [responseValues, execute] = useAxios<T>(config, {
    ...defaultAxiosOptions,
  });

  return [
    responseValues,
    (): AxiosPromise<T> => {
      return execute(config)
        .then((res) => res)
        .catch((err) => err);
    },
  ];
}
